import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { Platform } from '@ionic/angular';
import { ModelLocatorService } from 'src/app/services/config/model-locator.service';
import { MenuService } from 'src/app/services/menu-service/menu.service';

@Component({
    selector: 'app-mm-left-column',
    templateUrl: './mm-left-column.component.html',
    styleUrls: ['./mm-left-column.component.scss'],
})
export class MmLeftColumnComponent {

;

    menuLeftColum: any = [
        { key: 'perfil', label: 'Meu Perfil', route: '/profile', disabled: false, hidden: false },
        { key: 'pdvs', label: 'Meus PDVs', route: '/associate-pdv', disabled: false, hidden: false },
        { key: 'metas', label: 'Minhas Metas', route: '/goals', disabled: false, hidden: false },
        { key: 'ativacoes', label: 'Ativações', route: '/activation-list', disabled: false, hidden: false },
        { key: 'carteira', label: 'Minha Carteira', route: '/wallet', disabled: false, hidden: false },
        { key: 'extrato', label: 'Meu Extrato', route: '/extract', disabled: false, hidden: false },
        { key: 'interacao', label: 'Meus Resgates', route: '/my-rescue', disabled: false, hidden: false },
        { key: 'donations', label: 'Doações', route: '/donations', disabled: false, hidden: false },
        { key: 'qualidade', label: 'Minha Qualidade', route: '/quality', disabled: false, hidden: false },
        { key: 'faq', label: 'FAQ', route: '/faq', disabled: false, hidden: false },


    ];


    constructor(
        public modelLocator: ModelLocatorService,
        public platform: Platform,
        private router: Router,
        private menuService: MenuService
    ) {
    }


    async ngOnInit() {
        setTimeout(async () => {
            this.menuLeftColum = await this.menuService.disableOrHiddenMenu(this.menuLeftColum);
            // this.menuLeftColum = await this.hiddenMenu(this.menuLeftColum);
        }, 500)

    }

    hiddenMenu(menu: any) {
        return menu.map((item: any) => {
            return item;
        });
    }


    touchGoToRoute(rota: string) {
        this.router.navigate([rota]);
    };

}
